import { useEffect } from 'react';
import { Button } from '@givebutter/primitives/button';
import * as Dialog from 'components/dialog';
import { RequiredChecklistGenericConfetti } from 'components/required-checklist/RequiredChecklistGenericConfetti';
import { posthogEvents } from 'constants/posthog-events';
import { useAccountLocalStorage } from 'contexts/useAccountLocalStorage';
import { useCurrentUser } from 'customHooks/useCurrentUser';
import { usePosthog } from 'customHooks/usePosthog';
import MrButterSuperstar from 'images/mrbutter-superstar.svg';

interface ChecklistCompleteDialogProps extends Dialog.DialogProps {}
const ChecklistCompleteDialog = ({
    children,
    onOpenChange,
    ...rest
}: ChecklistCompleteDialogProps) => {
    const { firstName } = useCurrentUser();
    const { setHasSeenChecklistCompleteDialog, completedRequiredChecklistBetweenSessions } =
        useAccountLocalStorage(
            ({ setHasSeenChecklistCompleteDialog, completedRequiredChecklistBetweenSessions }) => ({
                setHasSeenChecklistCompleteDialog,
                completedRequiredChecklistBetweenSessions,
            }),
        );
    const { pushEvent } = usePosthog();

    useEffect(() => {
        if (rest.open) {
            pushEvent(posthogEvents.DASHBOARD_RAISED_ON_SUCCESS_DIALOG_VIEWED);
        }
    }, [rest.open, pushEvent]);

    return (
        <Dialog.Root
            {...rest}
            onOpenChange={open => {
                if (!open) {
                    pushEvent(posthogEvents.DASHBOARD_RAISED_ON_SUCCESS_DIALOG_DISMISSED);
                    setHasSeenChecklistCompleteDialog(true);
                }
                onOpenChange?.(open);
            }}
        >
            <Dialog.Portal>
                <Dialog.Overlay />
                <Dialog.Content className="max-w-[410px] items-center overflow-visible p-4 pt-6 sm:p-6">
                    {completedRequiredChecklistBetweenSessions && (
                        <RequiredChecklistGenericConfetti />
                    )}
                    <Dialog.Body>
                        <div>
                            <Dialog.Title>The world is your butter, {firstName} 🧈</Dialog.Title>
                            <p className="text-sm text-gray-600">
                                Congratulations on receiving your first donation! You're now set up
                                for fundraising success.
                            </p>
                        </div>
                        <Dialog.Cancel asChild>
                            <Button variant="solid" className={'w-full'}>
                                Return to dashboard
                            </Button>
                        </Dialog.Cancel>
                    </Dialog.Body>
                    <img
                        src={MrButterSuperstar}
                        aria-hidden
                        alt=""
                        className="motion-safe:animate-float absolute -top-28 ml-10 sm:-right-24 sm:-top-20"
                    />
                </Dialog.Content>
            </Dialog.Portal>
        </Dialog.Root>
    );
};

export { ChecklistCompleteDialog };
